export function maskPhoneLast4(input) {
  const digits = String(input || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 4) return digits;
  return `******${digits.slice(-4)}`;
}

